<script lang="ts">
	import { userBalances } from '$lib/home/store';
	import { depositInProgress, marginInput } from '$lib/home/userInteract/store';
	import ProcessingButton from '$lib/util/ProcessingButton.svelte';
	import { executeDeposit } from './adjustMargin';

	export let title: string;
	export let enabled: boolean = false;

	function enableButton() {
		enabled = true;
	}

	function handleClick() {
		if (!enabled) enableButton();
		else executeDeposit($marginInput, $userBalances.sUSD.balanceUSD);
	}
</script>

{#if $depositInProgress}
	<div class="my-4 sm:my-6">
		<ProcessingButton title={'Processing Deposit'} />
	</div>
{:else}
	<div
		class="flex-col justify-center items-center font-semibold text-center rounded-xl squircle-xl gap-3"
		class:disabledButton={!enabled}
		class:enableButton={enabled}
		class:bg-fx-gradient-9={enabled}
		on:click={handleClick}
		on:keydown={handleClick}
	>
		{#if enabled}
			Deposit
		{:else}
			<div>{title}</div>
			<div class=" text-xs" class:text-fx-grey-400={!enabled} class:text-fx-grey-100={enabled}>
				Click to proceed anyway
			</div>
		{/if}
	</div>
{/if}

<style>
	.disabledButton {
		@apply text-fx-grey-300 bg-fx-grey-600 cursor-not-allowed py-2;
	}
	.enableButton {
		@apply text-fx-black cursor-pointer py-4;
	}
</style>
